import SettlementService from "src/services/settlementService";

export const GET_SETTLEMENT_LIST = '@settlement/get-settlement-list';
export const GET_SETTLEMENT_LIST_SUCCESS = '@settlement/get-settlement-list-success';
export const GET_SETTLEMENT_LIST_FAILURE = '@settlement/get-settlement-list-failure';

export const CREATE_SETTLEMENT = '@settlement/create-settlement';
export const CREATE_SETTLEMENT_SUCCESS = '@settlement/create-settlement-success';
export const CREATE_SETTLEMENT_FAILURE = '@settlement/create-settlement-failure';


export const GET_ROLE = '@settlement/get-role';
export const GET_ROLE_SUCCESS = '@settlement/get-role-success';
export const GET_ROLE_FAILURE = '@settlement/get-role-failure';

export const GET_PARTY_BASED_ROLE = '@settlement/get-party-based-role';
export const GET_PARTY_BASED_ROLE_SUCCESS = '@settlement/get-party-based-role-success';
export const GET_PARTY_BASED_ROLE_FAILURE = '@settlement/get-party-based-role-failure';

export const CREATE_ORDER = '@settlement/create-order';
export const CREATE_ORDER_SUCCESS = '@settlement/create-order-success';
export const CREATE_ORDER_FAILURE = '@settlement/create-order-failure';

export const GET_SETTLEMENT_TYPE = '@settlement/get-settlement-type';
export const GET_SETTLEMENT_TYPE_SUCCESS = '@settlement/get-settlement-type-success';
export const GET_SETTLEMENT_TYPE_FAILURE = '@settlement/get-settlement-type-failure';

export const GET_LIST_OF_ORDER = '@settlement/get-list-of-order';
export const GET_LIST_OF_ORDER_SUCCESS = '@settlement/get-list-of-order-success';
export const GET_LIST_OF_ORDER_FAILURE = '@settlement/get-list-of-order-failure';

export const GET_UNSETTLED_LIST = '@settlement/get-unSettled-list';
export const GET_UNSETTLED_LIST_SUCCESS = '@settlement/get-unSettled-list-success';
export const GET_UNSETTLED_LIST_FAILURE = '@settlement/get-unSettled-list-failure';

export const GET_REPORT = '@settlement/get-report';
export const GET_REPORT_SUCCESS = '@settlement/get-report-success';
export const GET_REPORT_FAILURE = '@settlement/get-report-failure';

export const GET_LIST = '@settlement/get-list';
export const GET_LIST_SUCCESS = '@settlement/get-list-success';
export const GET_LIST_FAILURE = '@settlement/get-list-failure';

export const GET_DISCREPANCY_LIST = '@settlement/get-discrepancy-list';
export const GET_DISCREPANCY_LIST_SUCCESS = '@settlement/get-discrepancy-list-success';
export const GET_DISCREPANCY_LIST_FAILURE = '@settlement/get-discrepancy-list-failure';

export const RECONCILE = '@settlement/reconcile';
export const RECONCILE_SUCCESS = '@settlement/reconcile-success';
export const RECONCILE_FAILURE = '@settlement/reconcile-failure';

export const RECONCILE_STATUS = '@settlement/reconcile-status';
export const RECONCILE_STATUS_SUCCESS = '@settlement/reconcile-status-success';
export const RECONCILE_STATUS_FAILURE = '@settlement/reconcile-status-failure';

export const OTHER_PARTY_RECONCILE_STATUS = '@settlement/other-party-reconcile-status';
export const OTHER_PARTY_RECONCILE_STATUS_SUCCESS = '@settlement/other-party-reconcile-status-success';
export const OTHER_PARTY_RECONCILE_STATUS_FAILURE = '@settlement/other-party-reconcile-status-failure';

export const RECONCILATION_LIST = '@settlement/reconcile-list';
export const RECONCILATION_LIST_SUCCESS = '@settlement/reconcile-list-success';
export const RECONCILATION_LIST_FAILURE = '@settlement/reconcile-list-failure';

export const RECONCILATION_STATUS = '@settlement/reconcile-status';
export const RECONCILATION_STATUS_SUCCESS = '@settlement/reconcile-status-success';
export const RECONCILATION_STATUS_FAILURE = '@settlement/reconcile-status-failure';

export const EDIT_SETTLEMENT = '@settlement/edit-settlement';
export const EDIT_SETTLEMENT_SUCCESS = '@settlement/edit-settlement-success';
export const EDIT_SETTLEMENT_FAILURE = '@settlement/edit-settlement-failure';

export const GET_STATUS = '@settlement/get-status';
export const GET_STATUS_SUCCESS = '@settlement/get-status-success';
export const GET_STATUS_FAILURE = '@settlement/get-status-failure';


export function getSettledList(value, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_SETTLEMENT_LIST });
            const resp = await SettlementService.settlementList(value);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: GET_SETTLEMENT_LIST_SUCCESS,
                payload: resp,
            });
        } catch (error) {
            dispatch({ type: GET_SETTLEMENT_LIST_FAILURE });
            throw error;
        }
    };
}

export function getUnSettledList(customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_UNSETTLED_LIST });
            const resp = await SettlementService.unSettledList(customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: GET_UNSETTLED_LIST_SUCCESS,
                payload: resp,
            });
            return resp;
        } catch (error) {
            dispatch({ type: GET_UNSETTLED_LIST_FAILURE });
            throw error;
        }
    };
}
export function getReportAction( data, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_REPORT });
            const resp = await SettlementService.getReport(data, customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: GET_REPORT_SUCCESS,
                payload: resp,
            });
            return resp;
        } catch (error) {
            dispatch({ type: GET_REPORT_FAILURE });
            throw error;
        }
    };
}


export function getRole(customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_ROLE });
            const resp = await SettlementService.getRole(customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: GET_ROLE_SUCCESS,
                payload: resp,
            });
            return resp
        } catch (error) {
            dispatch({ type: GET_ROLE_FAILURE });
            throw error;
        }
    };
}

export function getRolePartyBased(role, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_PARTY_BASED_ROLE });
            const resp = await SettlementService.rolePartyBased(role, customerId);
        
            dispatch({
                type: GET_PARTY_BASED_ROLE_SUCCESS,
                payload: resp,
            });
            return resp
        } catch (error) {
            dispatch({ type: GET_PARTY_BASED_ROLE_FAILURE });
            throw error;
        }
    };
}

export function settlementTypeAction(value, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_SETTLEMENT_TYPE });
            const resp = await SettlementService.settlementType(value, customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: GET_SETTLEMENT_TYPE_SUCCESS,
                payload: resp,
            });
            return resp
        } catch (error) {
            dispatch({ type: GET_SETTLEMENT_TYPE_FAILURE });
            throw error;
        }
    };
}
export function settlement(orderIdArr, selectedSettlementType, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: CREATE_ORDER });
            const resp = await SettlementService.createSettlement(orderIdArr, selectedSettlementType, customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: CREATE_ORDER_SUCCESS,
                payload: resp,
            });
            return resp
        } catch (error) {
            dispatch({ type: CREATE_ORDER_FAILURE });
            throw error;
        }
    };
}

export function createSettlement(value, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: CREATE_SETTLEMENT });
            const resp = await SettlementService.createSettlement(value, customerId);
            console.log("fetchGreetings Action", resp);
            dispatch({
                type: CREATE_SETTLEMENT_SUCCESS,
                payload: resp,
            });
        } catch (error) {
            dispatch({ type: CREATE_SETTLEMENT_FAILURE });
            throw error;
        }
    };
}
export function getListOfOrder(value,selectedCollector, customerId) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_LIST_OF_ORDER });
            const resp = await SettlementService.ListOfOrder(value, selectedCollector, customerId);
    
            dispatch({
                type: GET_LIST_OF_ORDER_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: GET_LIST_OF_ORDER_FAILURE });
            throw error;
        }
    };
}
export function getOtherPartyListDiscrepancy() {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_LIST });
            const resp = await SettlementService.OtherPartyListDiscrepancy();
    
            dispatch({
                type: GET_LIST_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: GET_LIST_FAILURE });
            throw error;
        }
    };
}
export function getDiscrepancyList(type, id) {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_DISCREPANCY_LIST });
            const resp = await SettlementService.discrepancyList(type, id);
    
            dispatch({
                type: GET_DISCREPANCY_LIST_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: GET_DISCREPANCY_LIST_FAILURE });
            throw error;
        }
    };
}

export function ReconcileAction(payload) {
    return async (dispatch) => {
        try {
            dispatch({ type: RECONCILE });
            const resp = await SettlementService.reconcile(payload);
    
            dispatch({
                type: RECONCILE_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: RECONCILE_FAILURE });
            throw error;
        }
    };
}
export function ReconcileStatusAction(payload) {
    return async (dispatch) => {
        try {
            dispatch({ type: RECONCILE_STATUS });
            const resp = await SettlementService.reconcileStatus(payload);
    
            dispatch({
                type: RECONCILE_STATUS_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: RECONCILE_STATUS_FAILURE });
            throw error;
        }
    };
}
export function getOtherPartyListReconciliation() {
    return async (dispatch) => {
        try {
            dispatch({ type: OTHER_PARTY_RECONCILE_STATUS });
            const resp = await SettlementService.otherPartyListReconciliation();
    
            dispatch({
                type: OTHER_PARTY_RECONCILE_STATUS_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: OTHER_PARTY_RECONCILE_STATUS_FAILURE });
            throw error;
        }
    };
}

export function getReconciliationList(newValue) {
    return async (dispatch) => {
        try {
            dispatch({ type: RECONCILATION_LIST });
            const resp = await SettlementService.reconciliationList(newValue);
    
            dispatch({
                type: RECONCILATION_LIST_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: RECONCILATION_LIST_FAILURE });
            throw error;
        }
    };
}
export function ReconcileStatus(payload) {
    return async (dispatch) => {
        try {
            dispatch({ type: RECONCILATION_STATUS });
            const resp = await SettlementService.reconcileSts(payload);
    
            dispatch({
                type: RECONCILATION_STATUS_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: RECONCILATION_STATUS_FAILURE });
            throw error;
        }
    };
}

export function editSettlement(payload) {
    return async (dispatch) => {
        try {
            dispatch({ type: EDIT_SETTLEMENT });
            const resp = await SettlementService.editSettlement(payload);
    
            dispatch({
                type: EDIT_SETTLEMENT_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: EDIT_SETTLEMENT_FAILURE });
            throw error;
        }
    };
}

export function getStatus() {
    return async (dispatch) => {
        try {
            dispatch({ type: GET_STATUS });
            const resp = await SettlementService.getStatus();
    
            dispatch({
                type: GET_STATUS_SUCCESS,
                payload: resp,
            });
            return resp.data;
        } catch (error) {
            dispatch({ type: GET_STATUS_FAILURE });
            throw error;
        }
    };
}
